module.exports = __webpack_public_path__ + "static/media/country_gb.d26fab59.webp";